export const postUrls = {
  clientLeadSubmit: "enterprise/client_leads_submit/",
  updateViewedCookiePolicy: "visit/update_viewed_cookie_policy/",
}

export const getUrls = {
  viewedCookiePolicy: "visit/viewed_cookie_policy/",
  brand: 'custom/brand/',
  marketplaceTheme: "marketplace_theme/",
}



// WEBPACK FOOTER //
// ./src/common/urls.js